import { render, staticRenderFns } from "./CompanyViewDetail.vue?vue&type=template&id=2944333c&v-if=companyData.content&"
import script from "./CompanyViewDetail.vue?vue&type=script&lang=js&"
export * from "./CompanyViewDetail.vue?vue&type=script&lang=js&"
import style0 from "./CompanyViewDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports